"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(theme => ({
  card: {
    minWidth: 200,
    maxWidth: 345,
    textAlign: "center"
  },
  loaderContent: {
    paddingTop: 5,
    color: theme.palette.text.mediumShadeGray,
    fontSize: 14,
    letterSpacing: 0.25,
    lineHeight: "20px"
  },
  circularProgressContainer: {
    paddingTop: 20,
    textAlign: "center",
    "& div": {
      color: theme.palette.text.primary
    }
  },
  circularProgress: {
    display: "inline-block"
  }
}));